import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconEmailSeries = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M4.938 2c0-1.106.893-2 2-2h16c1.106 0 2 .894 2 2v.813l-8.69 6.437H14c-.119 0-.236.005-.352.015l-8.71-6.453V2ZM11.478 10.147 4.938 5.3v8.684H10v-.734c0-1.25.576-2.369 1.478-3.103ZM24.938 9.25V5.3l-5.33 3.95h5.33ZM12 13.375c0-1.106.894-2 2-2h16c1.106 0 2 .894 2 2v.813l-9.694 7.18a.527.527 0 0 1-.306.1v-2.867c0-2.547-1.794-4.617-4-4.617h-6v-.609ZM22 27.375h8c1.106 0 2-.894 2-2v-8.7l-8.5 6.3a2.523 2.523 0 0 1-1.5.494v3.906Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M2 16c-1.106 0-2 .894-2 2v.813l9.694 7.18c.087.063.193.1.306.1a.527.527 0 0 0 .306-.1L20 18.814V18c0-1.106-.894-2-2-2H2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "m20 21.3-8.5 6.3a2.523 2.523 0 0 1-3 0L0 21.3V30c0 1.106.894 2 2 2h16c1.106 0 2-.894 2-2v-8.7Z"
		})
	]
});
export default SvgIconEmailSeries;
